import React from "react";
import SpinnerIcon from "../../asset/scan/SpinnerIcon";

import "./Spinner.css";

function Spinner () {
    return (
        <div className="spinner"> 
            <SpinnerIcon />
        </div>
    );
}

export default Spinner;
